import styled, { keyframes, css } from "styled-components";

import { Button } from "components/ui/button"


const fadeInFromBottom = keyframes`
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeOutLeft = keyframes`
  0% {
    opacity: 1;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    transform: translateX(-50px);
  }
`;

export const AnimatedCard = styled.div`
  width: 100%;
  max-width: 700px;
  border-radius: 10px;
  padding: 30px;
  min-height:400px;
  margin-top: 20px;
  flex-direction: column;
  position: relative;
  will-change: transform, opacity;
  transform: translateZ(0);

  animation: ${({ isFadingOut }) =>
    isFadingOut
      ? css`
          ${fadeOutLeft} 0.4s cubic-bezier(0.22, 1, 0.36, 1) forwards
        `
      : css`
          ${fadeInFromBottom} 0.4s cubic-bezier(0.23, 1, 0.32, 1) forwards
        `};
`;

// Input grow and button shrink animations
const growHorizontal = keyframes`
  0% { width: 140px; opacity: 0; }
  100% { width: 100%; opacity: 1; }
`;

const shrinkToDot = keyframes`
  0% { transform: scale(1); opacity: 1; }
  80% { transform: scale(0.1); opacity: 0.2; }
  100% { transform: scale(0); opacity: 0; }
`;

export const TopBanner = styled.div`
  background-color: ${({ themeColors }) => themeColors.topBanner};
  width: 100%;
  height: 75px;
  display: flex;
  position:absolute;
  top:0;
  left:0;
`;



export const Container = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  width: 100%;
  font-family: 'Raleway', sans-serif;
  justify-content: center;
  position:relative;
  background-color: ${({ themeColors }) => themeColors.backgroundColor};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 700px;
  width: 100%;
`;

export const Card = styled.div`
  width: 100%;
  max-width: 800px;
  border-radius: 10px;
  padding: 30px;
  margin-top: 20px;
  flex-direction: column;
  position: relative;
  border: 1px solid #DFDFDF;
  background: #fff;
`;

export const Progress = styled.div`
  font-size: 12px;
  color: #2a3039;
  margin-bottom: 5px;
  position: absolute;
  top: 10px;
  right: 50%;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 20px;
`;

export const BackButton = styled(Button)`
  padding: 10px 20px;
  font-size: 1rem;
  color: ${({ themeColors }) => themeColors.buttonColor};
  background-color: ${({ themeColors }) => themeColors.secondaryButton};
  border: none;
  border-radius: 4px;
  cursor: pointer;
`;

export const NextButton = styled(Button)`
  padding: 10px 20px;
  font-size: 1rem;
  color: #fff;
  background-color: ${({ themeColors }) => themeColors.buttonColor};
  opacity: ${({ active }) => active ? 1 : 0.4};
  border: none;
  border-radius: 4px;
  cursor: pointer;
`;

export const CompletionCard = styled(Card)`
`;

export const CenteredContainer = styled.div`
  display: flex; 
  flex-direction: column; 
  align-items: center; 
  justify-content: center; 
  width: 100%;
`;

export const T1 = styled.div`
  font-size: 28px; 
  font-weight: bold; 
  margin-bottom: 20px; 
  margin-top: 10px; 
`;

export const Description = styled.div`
  max-width: 100%; 
  line-height: 1.6; 
  font-size: 14px; 
  font-weight: 400; 
  color: #2a3039; 
  margin-top: 3px;
  margin-bottom: 30px;
`;

export const RedError = styled.div`
  color: #f15062;
  font-size: 12px;
  margin-top: 10px;
`;

export const BottomBar = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 1000;
  width:100vw;
  pointer-events: none; /* allow overlay input to handle events */
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  pointer-events: auto;
`;

export const ProgressWrapper = styled.div`
  text-align: center;
`;

// Overlay chat-style input that appears centered and grows to full width
export const ChatInputContainer = styled.div`
  position: fixed;
  left: 50%;
  bottom: 12px;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px;
  width: 140px; /* start small, animation expands to 100% of max-width */
  max-width: 720px;
  z-index: 1100;
  pointer-events: auto;
  animation: ${growHorizontal} 280ms ease-out forwards;
`;

export const ChatInput = styled.input`
  flex: 1 1 auto;
  height: 44px;
  padding: 10px 44px 10px 14px;
  border-radius: 22px;
  border: 1px solid #e5e7eb;
  outline: none;
  background: #ffffff;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  font-size: 14px;
`;

export const SendButton = styled.button`
  position: absolute;
  right: 18px;
  height: 28px;
  width: 28px;
  border-radius: 14px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ themeColors }) => themeColors.buttonColor};
  color: #fff;
`;

// Wrapper to apply shrink-to-dot on the Next button when needed
export const NextButtonWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  ${(props) =>
    props.isShrinking &&
    css`
      animation: ${shrinkToDot} 260ms ease-in forwards;
    `}
`;